import { render, staticRenderFns } from "./WaiveSubmitPage.vue?vue&type=template&id=2f8afae8&scoped=true"
import script from "./WaiveSubmitPage.vue?vue&type=script&lang=js"
export * from "./WaiveSubmitPage.vue?vue&type=script&lang=js"
import style0 from "./WaiveSubmitPage.vue?vue&type=style&index=0&id=2f8afae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8afae8",
  null
  
)

export default component.exports